module.exports = __webpack_public_path__ + "img/wind-hazard.bac97922.png";